import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import EntryPoint from "../../../pages/Profile/Leads/EntryPoint";
import { LeadsContainerProps } from "../../../interfaces/containers";
import { getLeads, getLeadsByBrand } from "../../../actions/leads";
import { getPublication } from "../../../actions/publication";

function mapStateToProps(state: LeadsContainerProps) {
    return{ 
        fetchingLeads: state.leads.fetching,
        leads: state.leads.leads,
        publication: state.publication.data,
        fetchingPublication: state.publication.fetching,
        user: state.auth.user
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getLeads,
        getLeadsByBrand,
        getPublication
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);